import Loader from "react-loader-spinner";
import momentJalaali from "moment-jalali";
import DatePicker from "react-datepicker2";
import { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { EyeFill, EyeSlashFill, FileEarmarkExcelFill, FileEarmarkTextFill, List, PrinterFill, Search } from "react-bootstrap-icons";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { faBroom, faFileInvoice } from "@fortawesome/free-solid-svg-icons";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getInvoiceDetailsReport } from "../store/api/ReportsAPI";
import { exportToExcel } from "../../store/api/CommonFunctions";
import BihamtaTable from "../../Components/BihamtaTable";
import { invoiceTypesArray } from "../../store/api/CommonFunctions";
import ModalSearchStorage from "../../Components/Modals/ModalSearchStorage";
import ModalSelectUser from "../../Components/Modals/ModalSelectUser";
import ModalSelectStaff from "../../Components/Modals/ModalSelectStaff";
import { getSystemSettings } from "../store/api/Invoice";
import ModalProducts from "../../Components/Modals/ModalProducts";
import ModalSelectCustomer from "../../Components/Modals/ModalSelectCustomer";

const InvoiceDetailsReport = () => {
    const { register, handleSubmit } = useForm();
    const history = useHistory();
    const frmFilters = useRef();
    const dispatch = useDispatch();
    const [pending, setPending] = useState(false);
    const [createBy, setCreateBy] = useState(null);
    const [showFilter, setShowFilter] = useState(true);
    const [selectedStaff, selectStaff] = useState(null);
    const [selectedProduct, selectProduct] = useState(null);
    const [popUser, setPopUser] = useState({ show: false });
    const [sourceStorage, setSourceStorage] = useState(null);
    const [popStaff, setPopStaff] = useState({ show: false });
    const [selectedCustomer, selectCustomer] = useState(null);
    const [popStorage, setPopStorage] = useState({ show: false });
    const [popProduct, setPopProduct] = useState({ show: false });
    const [popCustomer, setPopCustomer] = useState({ show: false });
    const [filteredInvoiceType, setInvoiceTypeFilter] = useState('');
    const { filterData, systemSettings } = useSelector(state => {
        return {
            filterData: state.ReportReducer.invoiceDetailsFilters,
            systemSettings: state.InvoiceReducer.systemSettings
        }
    });
    const [dateFilters, setDateFilters] = useState({
        ContactDateFrom: filterData?.ContactDateFrom,
        ContactDateTo: filterData?.ContactDateTo
    });
    const settingNames = ["ProductGrouppingType"];
    const pgType = Array.isArray(systemSettings) ?
        Number(systemSettings.find(s => s.SettingName === "ProductGrouppingType")?.SettingValue ?? "") : 1;
    const hasDiscount = ["Sale", "PreSale", "Purchase", "PrePurchase", "ReturnFromSale", "ReturnFromPurchase", ""];
    const hidePrices = ["Resid", "Havaleh", "Transfer"];
    const hideDestStg = ["Sale", "Havaleh", "ReturnFromPurchase", "PreSale", "ServiceInvoice"];
    const hideStg = ["Resid", "Purchase", "PrePurchase"];
    const tableCols = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "نوع فاکتور", colName: "PInvoiceType", showCondition: () => filteredInvoiceType === "" },
        { colTitle: "شماره فاکتور", colName: "InvoiceNumber", showInMobile: true },
        { colTitle: "تاریخ فاکتور", colName: "PContactDate", showInMobile: true },
        { colTitle: (filteredInvoiceType === "Borrow" || filteredInvoiceType === "ReturnFromBorrow" ? "نماینده/تکنسین" : "طرف حساب"), colName: "CustomerName", showInMobile: true, showCondition: () => !hidePrices.includes(filteredInvoiceType) },
        { colTitle: "کد کالا", colName: "ProductCode" },
        { colTitle: "مشخصات کالا", colName: "ProductName+ProductModel", colType: "string" },
        { colTitle: "تعداد", colName: "ProductCount" },
        { colTitle: "قیمت واحد", colName: "UnitPrice", colType: "currency", showCondition: () => !hidePrices.includes(filteredInvoiceType) },
        { colTitle: "جمع", colName: "TotalPrice", colType: "currency" },
        { colTitle: "تخفیف", colName: "Discount", colType: "currency", showCondition: () => hasDiscount.includes(filteredInvoiceType) },
        { colTitle: "مالیات", colName: "Tax", colType: "currency", showCondition: () => hasDiscount.includes(filteredInvoiceType) },
        { colTitle: "قابل پرداخت", colName: "PureTotalPrice", colType: "currency", showCondition: () => !hidePrices.includes(filteredInvoiceType) },
        { colTitle: "جمع کل فاکتور", colName: "InvoicePureTotalPrice", colType: "currency", showCondition: () => !hidePrices.includes(filteredInvoiceType) },
        { colTitle: "ثبت کننده", colName: "CreateByName" },
        { colTitle: "انبار مبدا", colName: "StorageName", showCondition: () => !hideStg.includes(filteredInvoiceType) },
        { colTitle: "انبار مقصد", colName: "DestStorageName", showCondition: () => !hideDestStg.includes(filteredInvoiceType) },
        { colTitle: "فروشنده/خریدار/انباردار", colName: "StaffName" }
    ]
    const rowButtons = [
        {
            type: "common", title: "نمایش فاکتور", className: "group-Btn-smalll", icon: <FileEarmarkTextFill color="#1b9964" size={18} className="rowBtn" />,
            tooltip: "نمایش فاکتور(برای نمایش در تب جدید کلید Ctrl را نگه دارید)", onclick: showInvoice
        }
    ]
    function showInvoice(row) {
        if (row.e.ctrlKey) {
            window.open(`/Sale/Invoice/${row.InvoiceTypeStr}/${row.InvoiceID}/${row.IsFormal}`);
        }
        else {
            history.push(`/Sale/Invoice/${row.InvoiceTypeStr}/${row.InvoiceID}/${row.IsFormal}`);
        }
    }
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    function search(data) {
        const contactDateFrom = document.getElementsByName("ContactDateFrom")[0].value;
        const contactDateTo = document.getElementsByName("ContactDateTo")[0].value;
        if (contactDateFrom !== '') {
            data.ContactDateFrom = dateFilters.ContactDateFrom;
            data.PContactDateFrom = contactDateFrom;
        }
        if (contactDateTo !== '') {
            data.ContactDateTo = dateFilters.ContactDateTo;
            data.PContactDateTo = contactDateTo;
        }
        data.Skip = 0;
        dispatch(getInvoiceDetailsReport(data))
    }
    function onInvoiceTypeChanges(e) {
        setInvoiceTypeFilter(e.target.value);
        filterData.InvoiceType = e.target.value;
        search(filterData);
    }
    function clearFilters() {
        frmFilters.current.reset();
        setDateFilters({
            ContactDateFrom: null,
            ContactDateTo: null
        })
        dispatch(getInvoiceDetailsReport({ Skip: 0, Take: 10, InvoiceType: "Sale" }));
    }
    function toExcel() {
        const url = "api/InvoiceAPI/GetInvoiceDetailsReport";
        const searchArgs = { ...filterData };
        searchArgs.Skip = 0;
        searchArgs.Take = 0;
        setPending(true);
        exportToExcel("InvoiceDetailsReport", searchArgs, url, "post", tableCols, () => setPending(false));
    }
    function printReport(e) {
        const searchArgs = { ...filterData };
        searchArgs.Skip = 0;
        searchArgs.Take = -1;
        history.push({
            pathname: `/PrintViewer/InvoiceDetailsReport/${e.ctrlKey}`,
            state: {
                dataUrl: `api/InvoiceAPI/GetInvoiceDetailsReport`,
                method: "post",
                fetchBody: JSON.stringify(searchArgs)
            }
        });
    }
    function showCreateBy() {
        filterData.CreateById = null;
        filterData.CreateByName = null;
        setPopUser({ show: true, selectUserWithName: setCreateBy });
    }
    function showModalStorage(e) {
        if (e.key) {
            if (e.key === "Tab" || e.altKey || e.ctrlKey || e.shiftKey || !(e.key.match(/[a-z,آ-ی,' ']/i))) {
                return;
            }
            e.preventDefault();
        }
        filterData.StorageID = null;
        filterData.StorageName = null;
        setPopStorage({ show: true, setStorageData: setSourceStorage })
    }
    function showModalStaff(e) {
        if (e.key) {
            if (e.key === "Tab" || e.altKey || e.ctrlKey || e.shiftKey || !(e.key.match(/[a-z,آ-ی,' ']/i))) {
                return;
            }
            e.preventDefault();
        }
        if (filterData) {
            filterData.StaffID = null;
            filterData.StaffName = null;
        }
        setPopStaff({ show: true, forPersonnel: false, onSelect: selectStaff });
    }
    function showModalCustomer(e) {
        if (e.key) {
            if (e.key === "Tab" || e.altKey || e.ctrlKey || e.shiftKey || !(e.key.match(/[a-z,آ-ی,' ']/i))) {
                return;
            }
            e.preventDefault();
        }
        if (filterData) {
            filterData.CustomerID = null;
            filterData.CustomerName = null;
        }
        setPopCustomer({ show: true, value: e.key, invoiceCustomers: true, setCustomerData: selectCustomer });
    }
    function showModalProduct(e) {
        if (e.key) {
            if (e.key === "Enter" || e.key === "Tab" || e.altKey || e.ctrlKey || e.shiftKey || !(e.key.match(/[a-z,آ-ی,' ']/i))) {
                return;
            }
            e.preventDefault();
        }
        if (filterData) {
            filterData.ProductID = null;
            filterData.ProductName = null;
        }
        const setProductData = (data) => {
            if (data) {
                const dataArr = [data.HolderName, data.ProductName, data.ProductModel];
                data.ProductName = dataArr.filter(d => d?.length > 0).join('-');
            }
            selectProduct(data);
        }
        setPopProduct({ show: true, value: e.key, setProductData: setProductData, forStorageReport: true });
    }
    useEffect(() => {
        document.body.className = "notMain";
        dispatch(getSystemSettings(settingNames));
    }, [])
    return (
        <div className="container-fluid mt-4">
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faFileInvoice} size="lg" />&nbsp;
                    گزارش ریز فاکتورها
                </Card.Header>
                <Card.Body className="bodyStyle">
                    <ModalSearchStorage popData={popStorage} setStoragePoup={setPopStorage} />
                    <ModalSelectUser popData={popUser} setUserPop={setPopUser} />
                    <ModalSelectStaff popData={popStaff} setPopSelectStaff={setPopStaff} />
                    <ModalSelectCustomer popData={popCustomer} setCustomerPopup={setPopCustomer} />
                    <ModalProducts popData={popProduct} setProductPopup={setPopProduct} productGrouppingType={pgType} />
                    <form readOnly onSubmit={handleSubmit(search)} ref={frmFilters}>
                        <Row id="divFilters" className="rowBorder" >
                            <div className="rowTitle">
                                فیلترهای جستجو
                                &nbsp;
                                {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                                {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                                {showFilter && <FontAwesomeIcon icon={faBroom} size="lg" style={{ cursor: "pointer", color: "#007e80" }} onClick={clearFilters} />}
                            </div>

                            <Col md={2} className="form-group">
                                <label>نوع فاکتور: </label>
                                <select className="search-input" name="InvoiceType" ref={register({})} defaultValue={filterData?.InvoiceType ?? "Sale"} onChange={onInvoiceTypeChanges}>
                                    <option value="">انتخاب کنید</option>
                                    {invoiceTypesArray.map((type, i) => <option key={i} value={type.TypeName}>{type.TypeStr}</option>)}
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>کالا:</label>
                                <input type="hidden" name="ProductID" value={selectedProduct?.ProductID ?? filterData?.ProductID ?? ""} readOnly ref={register({})} />
                                <input type="text" className="search-input" readOnly onKeyDown={showModalProduct} name="ProductName" ref={register({})}
                                    value={selectedProduct?.ProductName ?? filterData?.ProductName ?? ""} />
                                <Button className="btn-input-tiny" style={{ top: 22 }} onClick={showModalProduct}><List size={17} /></Button>
                            </Col>
                            {!hidePrices.includes(filteredInvoiceType) ?
                                <Col md={2} className="form-group">
                                    <label>طرف حساب:</label>
                                    <input type="hidden" name="CustomerID" value={selectedCustomer?.ID ?? filterData?.CustomerID ?? ""} ref={register({})} />
                                    <input type="hidden" name="CustomerCat" value={selectedCustomer?.Cat ?? filterData?.CustomerCat ?? ""} ref={register({})} />
                                    <input type="text" className="search-input" readOnly onKeyDown={showModalCustomer}
                                        value={selectedCustomer?.Name ?? filterData?.CustomerName ?? ""} ref={register({})} name="CustomerName" />
                                    <Button className="btn-input-tiny" style={{ top: 22 }} onClick={showModalCustomer}><List size={17} /></Button>
                                </Col> : null}
                            <Col md={2} className="form-group">
                                <label>تاریخ فاکتور از: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input mt-0" name="ContactDateFrom"
                                    value={dateFilters.ContactDateFrom ? momentJalaali(dateFilters.ContactDateFrom) : null}
                                    onChange={value => setDateFilters({ ...dateFilters, ContactDateFrom: value.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ فاکتور تا: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input mt-0" name="ContactDateTo"
                                    value={dateFilters.ContactDateTo ? momentJalaali(dateFilters.ContactDateTo) : null}
                                    onChange={val => setDateFilters({ ...dateFilters, ContactDateTo: val.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>ثبت کننده:</label>
                                <input type="hidden" name="CreateByID" value={createBy?.ID ?? filterData?.CreateByID ?? ""} ref={register({})} />
                                <input type="text" className="search-input" readOnly onKeyDown={showCreateBy} name="CreateByName" ref={register({})}
                                    value={createBy?.Name ?? filterData?.CreateByName ?? ""} />
                                <Button className="btn-input-tiny" onClick={showCreateBy} style={{ top: 22 }}><List size={17} /></Button>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>انبار:</label>
                                <input type="hidden" name="StorageID" value={sourceStorage?.StorageID ?? filterData?.StorageID ?? ""} ref={register({})} />
                                <input type="text" className="search-input" readOnly onKeyDown={showModalStorage} name="StorageName" ref={register({})}
                                    value={sourceStorage?.StorageName ?? filterData?.StorageName ?? ""} />
                                <Button className="btn-input-tiny" style={{ top: 22 }} onClick={showModalStorage} ><List size={17} /></Button>
                            </Col>
                            <Col md={2} className="form-group">
                                <label className="ellipsisLabel" title="فروشنده/خریدار/انباردار">فروشنده/خریدار/انباردار:</label>
                                <input type="hidden" name="StaffID" ref={register({})} value={selectedStaff?.ID ?? filterData?.StaffID ?? ""} readOnly />
                                <input type="text" className="search-input" readOnly onKeyDown={showModalStaff} value={selectedStaff?.LastName ?? filterData?.StaffName ?? ""} name="StaffName" ref={register({})} />
                                <Button className="btn-input-tiny" style={{ top: 22 }} onClick={showModalStaff}><List size={17} /></Button>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تعداد در صفحه:</label>
                                <select className="search-input" name="Take" ref={register({})} defaultValue={filterData?.Take ?? 10}>
                                    <option value="">انتخاب کنید</option>
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                    <option value={1000}>1000</option>
                                    <option value={-1}>تمام ردیفها</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>مرتب سازی براساس:</label>
                                <select className="search-input" defaultValue="ContactDate" ref={register({})} name="OrderBy">
                                    <option value="ContactDate">تاریخ فاکتور-صعودی</option>
                                    <option value="ContactDate DESC">تاریخ فاکتور-نزولی</option>
                                    <option value="Number">شماره فاکتور-صعودی</option>
                                    <option value="Number DESC">شماره فاکتور-نزولی</option>
                                    <option value="TotalPrice">مجموع فاکتور-صعودی</option>
                                    <option value="TotalPrice DESC">مجموع فاکتور-نزولی</option>
                                </select>
                            </Col>
                        </Row>
                        <Button type="submit" className="group-Btn-large mt-1"><Search size={17} />&nbsp;جستجو&nbsp;</Button>
                    </form>
                    {!pending &&
                        <div style={{ padding: 0, width: "100%", textAlign: "left", marginTop: "5px" }}>
                            <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                            <PrinterFill color="blue" size={25} style={{ cursor: "pointer" }} className="hoverIcon" onClick={printReport} />
                        </div>}
                    {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                    <BihamtaTable columns={tableCols} rowButtons={rowButtons} filterData={filterData} reducerName="ReportReducer" objectName="invoiceDetailsReport"
                        searchMethod={(data) => dispatch(getInvoiceDetailsReport(data))} hasPaging style={{ whiteSpace: "nowrap" }} className="mt-0" maxHeight={500} />
                </Card.Body>
            </Card>
        </div>
    )
}
export default InvoiceDetailsReport;